import {sendPetition} from '../../js/scripts';

var state = {
	
}

var getters = {
	
}

var actions = {

}

var mutations = {
	
}

export var checkout = {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};